import http from '@services/http'

export default {
  getUsers(data: object): Promise<any> {
    return http.get('user', data || {})
  },

  createUser(data: object): Promise<any> {
    return http.post('user/create', data || {})
  },

  modifyUser(data: object): Promise<any> {
    return http.post('user/modify', data || {})
  },

  deleteUser(data: object): Promise<any> {
    return http.post('user/delete', data || {})
  },
  getLoginUserDetail(data?: object): Promise<any> {
    return http.get('user-api/user/detail', data || {})
  },
  getUserDetail(data?: object): Promise<any> {
    return http.get('user-api/na/user/detail', data || {})
  },
  updateUser(data?: object): Promise<any> {
    return http.post('user-api/user/update', data || {})
  },
  updatePwd(data?: object): Promise<any> {
    return http.post('user-api/user/updatePwd', data || {})
  }
}
